import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "m-searchListItem__block" }
const _hoisted_3 = { class: "a-badgeThumb" }
const _hoisted_4 = {
  key: 0,
  class: "a-picture -with-ratio",
  style: {"padding-bottom":"100%"}
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "a-picture -with-ratio",
  style: {"padding-bottom":"100%"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "//content.eventim.com/sc_f50ef/static/themes/responsive/integration/oeticket/images/elements/artistBlank.jpg",
  alt: "",
  role: "presentation"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "leaf ta"
}
const _hoisted_10 = { class: "m-searchListItem__block" }
const _hoisted_11 = { class: "m-searchListItem__title -artist" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "m-searchListItem__block" }, null, -1)
const _hoisted_13 = { class: "m-searchListItem__block" }
const _hoisted_14 = {
  class: "a-btnCta",
  type: "button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _directive_translate = _resolveDirective("translate")!

  return (_ctx.item.title)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        class: "m-searchListItem",
        href: _ctx.item.url,
        "data-qa": "search-list-item"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.item.image)
              ? (_openBlock(), _createElementBlock("picture", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _ctx.staticUrl + _ctx.item.image,
                    alt: "",
                    role: "presentation"
                  }, null, 8, _hoisted_5)
                ]))
              : (_openBlock(), _createElementBlock("picture", _hoisted_6, _hoisted_8)),
            (_ctx.item.isTicketAlarmEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.stripTags(_ctx.item.title)), 1)
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_14, [
            _createTextVNode("Show more")
          ])), [
            [_directive_translate, { key: _ctx.Translation.Show_more }]
          ]),
          _createVNode(_component_IconComponent, {
            class: "m-searchListItem__iconCta",
            iconId: _ctx.IconName.Chevron
          }, null, 8, ["iconId"])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}